export default function createSpinner() {
    const spinner = document.createElement('div')
    spinner.classList.add('d-flex')
    spinner.classList.add('justify-content-center')
    const innerDiv = document.createElement('div')
    innerDiv.classList.add('spinner-border')
    innerDiv.attributes.role = 'status'
    const span = document.createElement('span')
    span.classList.add('visually-hidden')
    span.innerText = 'Loading'
    spinner.appendChild(innerDiv)
    innerDiv.appendChild(span)
    return spinner
}
